<template>
  <div class="third">
    <div class="third-formOne">
      <div class="formOne-btn">
        <div class="btn-left">
          <span class="left-back-icon" @click="changeComponent">
            <i class="el-icon-arrow-left"></i>
            <span class="left-back-title">返回</span>
          </span>
          <span class="left-back-shu">
            <span class="left-back-shu-content"></span>
          </span>
          <span class="left-back-content">服务列表 > 服务详情</span>
        </div>
        <!-- <div class="btn-right">
          <el-button class="btn-two" type="default" @click="reset">重置</el-button>
          <el-button class="btn-two" type="primary" @click="commit">保存</el-button>
        </div> -->
      </div>
      <el-form
        :model="otherForm"
        :rules="rules"
        ref="otherForm"
        label-width="86px"
        :show-message="false"
        @validate="validateValue"
      >
        <div class="formOne-forms">
          <div class="forms-one">
            <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content">基本信息</span>
              </div>
            </div>
            <div class="one-list">
              <div class="list-one-line">
                <el-form-item label="服务名称" prop="service_name">
                  <div class="text-label">{{ otherForm.service_name }}</div>
                </el-form-item>
                <el-form-item label="访问地址" prop="service_url">
                  <div class="text-label">{{ otherForm.service_url }}</div>
                </el-form-item>
                <el-form-item label="服务图标" prop="service_icon">
                  <div class="text-label"><img v-if="otherForm.service_icon" :src="otherForm.service_icon" class="avatar"></div>
                </el-form-item>
                <el-form-item label="服务状态" prop="">
                  <el-checkbox-group v-model="otherForm.status" disabled style="padding-left: 10px">
                    <el-checkbox
                      v-for="(item,index) in serviceStatus"
                      :key="index"
                      :label="item.value"
                    >{{item.label}}</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </div>
            </div>
          </div>

          <div class="forms-one">
            <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content">服务分类</span>
              </div>
            </div>
            <div class="one-list">
              <div class="list-one-line">
                <el-form-item label="服务场景" prop="service_scene">
                  <div class="text-label">{{ otherForm.serviceScene }}</div>
                </el-form-item>
              </div>
              <div class="list-one-line">
                <el-form-item label="服务类型" prop="service_type">
                  <div class="text-label">{{ otherForm.serviceType }}</div>
                </el-form-item>
              </div>
            </div>
          </div>

          <div class="forms-one">
            <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content">接入及使用方式</span>
              </div>
            </div>
            <div class="one-list">
              <div class="list-one-line">
                <el-form-item label="接入方式" prop="access_way">
                  <div class="text-label">{{ otherForm.accessWay }}</div>
                </el-form-item>
                <el-form-item label="使用环境" prop="">
                  <span
                    class="text-label"
                  >
                    {{ otherForm.userEnvironment }}
                  </span>
                </el-form-item>
                <div v-if="oneStepPanel">
                  <el-form-item label="打开方式" prop="open_way">
                    <div class="text-label">{{ getLabels(otherForm.open_way, DKFSoptions) }}</div>
                  </el-form-item>
                  <el-form-item label="默认展示方式" prop="def_show_way">
                    <div class="text-label">{{ getLabels(otherForm.def_show_way, ZSFSoptions) }}</div>
                  </el-form-item>
                  <el-form-item label="默认方式切换" prop="show_way_change">
                    <div class="text-label">{{ getLabels(otherForm.show_way_change, ZSFSQHoptions) }}</div>
                  </el-form-item>
                </div>
              </div>
            </div>
          </div>

          <div class="forms-one">
            <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content">服务提醒</span>
              </div>
            </div>
            <div class="one-list">
              <div class="list-one-line">
                <el-form-item label="徽标提醒" prop="show_unread">
                  <el-checkbox-group v-model="otherForm.show_unread" disabled style="padding-left: 10px;">
                    <el-checkbox :label="1">未读消息</el-checkbox>
                    <span class="avatar-uploader-text showUnread">
                      （99封顶，超出部分用“+”号表示）
                       <el-tooltip class="item" effect="light" content="如勾选，请前往【服务中台】或【API查阅平台】查看服务徽标提醒接入方式" placement="top-start">
                          <i class="el-icon-question" style="vertical-align: middle;"></i>
                      </el-tooltip>
                    </span>
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item label="上架标记" prop="shelf_label_id">
                  <div class="text-label">{{ otherForm.shelfLabel }}</div>
                </el-form-item>
                <el-form-item label="到期时间" prop="expire_date" v-if="otherForm.shelf_label_id">
                  <span class="text-label">{{ otherForm.expire_date }}</span>
                  <span class="avatar-uploader-text"> 到期后，服务自动取消标记</span>
                </el-form-item>
              </div>
            </div>
          </div>

          <div class="forms-one">
            <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content">服务授权</span>
              </div>
            </div>
            <div class="one-list">
              <div class="list-one-line">
                <el-form-item label="使用角色" prop="service_use_need_login">
                  <el-tag
                    v-for="tag in roleTags"
                    :key="tag.id">
                    {{tag.name}}
                  </el-tag>
                </el-form-item>
                <el-form-item label="使用标签" prop="service_use_need_login">
                  <el-tag
                    v-for="tag in labelTags"
                    :key="tag.id">
                    {{tag.name}}
                  </el-tag>
                </el-form-item>
                <el-form-item label="服务认证" prop="service_use_need_login">
                  <el-checkbox-group v-model="otherForm.service_use_need_login" disabled>
                    <el-checkbox :label="1">需要登录</el-checkbox>
                    <span class="avatar-uploader-text showUnread">
                      （勾选后，服务需登录后才可使用）
                    </span>
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item label="其他" prop="">
                  <el-checkbox-group v-model="otherForm.service_visible_need_login" disabled>
                    <el-checkbox :label="1">未登录可见</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </div>
            </div>
          </div>

        </div>
      </el-form>
    </div>
    
  </div>
</template>

<script>
import { removeStore, getStore } from "@/utils/store";
import { mapState, mapActions } from "vuex";
import { cloneDeep } from "lodash";
export default {
  name: "formSeven",
  data() {
    var validate = (rule, value, callback) => {
      const select = new Date(value).getTime()
      const now = new Date().getTime()
      if (select < now) {
        return callback(new Error('选择时间不能低于当前时间'));
      }
      callback();
    }
    return {
      treeDialogVisible: false,
      imageUrl: '',
      rules: {
        // service_name: [{ required: true, message: "请输入服务名称", trigger: "blur" }],
        // service_url: [
        //   { required: true, message: "请输入访问地址",trigger: "blur" },
        //   { type: "string", pattern: /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/,  message: "请输入正确格式的访问地址", trigger: "blur" }
        // ],
        // service_icon: [{ required: true, message: "请上传服务图标", trigger: "change" }],
        // service_scene: [{ required: true, message: "请选择服务场景", trigger: "change" }],
        // service_type: [{ required: true, message: "请选择服务类型", trigger: "change" }],
        // access_way: [{ required: true, message: "请选择接入方式", trigger: "change" }],
        // open_way: [{ required: true, message: "请选择打开方式", trigger: "change" }],
        // def_show_way: [{ required: true, message: "请选择默认展开方式", trigger: "change" }],
        // show_way_change: [{ required: true, message: "请选择展示方式切换", trigger: "change" }],
        // expire_date: [{ required: true, validator: validate, message: "请选择到期时间", trigger: "change" }],

      },
      otherForm: {
        service_name: '',
        service_url: '', // 访问地址
        service_icon: '',
        status: false, // 服务状态
        service_scene: '',
        service_type: '',
        access_way: '', // 接入方式
        user_environment: [], //使用环境
        open_way: '',
        def_show_way: '',
        show_way_change: '', //默认方式切换
        show_unread: false, // 徽标是否提醒
        shelf_label_id: '', // 上架标记
        expire_date: '',
        service_use_need_login: false, //服务认证 是否需要登录才可以使用服务
        service_visible_need_login: false, //其他
      },
      originalData: {},
      title: "",
      rowData: null,
      countNum: 1, //用于显示第一个错误
      treeTitle: '新增授权角色',
      oneStepPanel: false, // 一站式服务大厅面板
      SJBJoptions: [],
      serviceStatus: [
        {
          value: 1,
          label: '保存后默认上架',
        }
      ],
      userEnvironment: [
        {
          value: 1,
          label: 'APP',
        },
        {
          value: 2,
          label: '一站式服务大厅',
        },
        {
          value: 3,
          label: '应用超市',
        },
      ],
      defaultProps: {
        children: 'children',
        label: 'roleName'
      },
      roleTags: [],
      labelTags: [],
      roleOrlabel: true, // ture为role false为label
      treeData: [],
      roleTree: [], //角色列表
      labelTree: [], // 标签列表
    };
  },
  computed: {
    ...mapState({
      userInfo: state => {},
      JRFSoptions: (state) => {
        const { dictList } = state.serviceList;
        if (dictList) {
          const list = dictList.filter(item => item.type === 2);
          return list
        }
        return [];
      },
      DKFSoptions: (state) => {
        const { dictList } = state.serviceList;
        if (dictList) {
          const list = dictList.filter(item => item.type === 3);
          return list
        }
        return [];
      },
      ZSFSoptions: (state) => {
        const { dictList } = state.serviceList;
        if (dictList) {
          const list = dictList.filter(item => item.type === 4);
          return list
        }
        return [];
      },
      ZSFSQHoptions: (state) => {
        const { dictList } = state.serviceList;
        if (dictList) {
          const list = dictList.filter(item => item.type === 5);
          return list
        }
        return [];
      },
    }),
  },
  async created() {
    await this.init();
    const rowData = getStore({
      name: "rowData",
      type: "session"
    });
    // console.log(rowData);
    if (rowData) {
      this.rowData = rowData;
      const userEnvironment = rowData.user_environment.split(',').map(item => Number(item))
      this.handleChange(userEnvironment);
      this.getRolelist(); // 获取使用角色
      this.getLabellist(); // 获取使用角色

      const params = {
        status: rowData.status === 1 ? true : false,
        show_unread: rowData.show_unread === 1 ? true : false,
        service_use_need_login: rowData.service_use_need_login === 1 ? true : false,
        service_visible_need_login: rowData.service_visible_need_login === 1 ? true : false,
        user_environment: userEnvironment.length === 0 ? [] : userEnvironment,
        access_way: Number(rowData.access_way),
        open_way: Number(rowData.open_way),
        def_show_way: Number(rowData.def_show_way),
        show_way_change: Number(rowData.show_way_change),
      }
      const obj = Object.assign(this.otherForm, rowData, params)
      console.log(obj)
      return;
    }
  },
  methods: {
    getLabels(id, options) {
      const [res] = options.filter(item => item.id === id)
      return res.value
    },
    // 获取上架标记/标签树/角色数
    async init() {
      const res1 = await this.$store.dispatch('serviceShelfLabel')
        if (res1.data.status === 1000) {
          const { result } = res1.data;
          this.SJBJoptions = result;
        }
      const res2 = await this.$store.dispatch('getServiceRoleList')
        if (res2.data.status === 1000) {
          const { result } = res2.data;
          this.roleTree = result;
        }
      const res3 = await this.$store.dispatch('getServiceEduLableList')
        if (res3.data.status === 1000) {
          const { result } = res3.data;
          this.labelTree = result[0].children;
        }
    },
    getRolelist() {
      let childrenList = [] // 整理角色列表 去除一级 只留二级数据
      this.roleTree.forEach(element => {
        element.children.forEach((ele) => {
          childrenList.push(ele)
        })
      });
      this.rowData.role_id.split(',').forEach(element => {
        let role = childrenList.map((item) => {
          if (item.roleId === element) {
            return {
              id: item.roleId,
              name: item.roleName,
            }
          }
        })
        role = role.filter(item => item);
        role.forEach(ele => this.roleTags.push(ele))
      });
    },
    getLabellist() {
      let childrenList = [] // 整理角色列表 去除一级 只留二级数据
      this.labelTree.forEach(element => {
        if (!element.children) return;
        element.children.forEach((ele) => {
          childrenList.push(ele)
        })
      });
      this.rowData.label_info_id.split(',').forEach(element => {
        let role = childrenList.map((item) => {
          if (item.lableId === element) {
            return {
              id: item.lableId,
              name: item.lableName,
            }
          }
        })
        role = role.filter(item => item);
        role.forEach(ele => this.labelTags.push(ele))
      });
    },
    // 改变index页面的component的值
    changeComponent() {
      this.$emit("changeComponent", "homePage");
      removeStore({
        name: "rowData",
        type: "session"
      });
    },
    // 验证
    validateValue(prop, msgStatus, validateMessage) {
      if (!this.countNum && !msgStatus) {
        this.countNum += 1;
        if (validateMessage) {
          this.$message.error(validateMessage);
        }
      }
    },
    // 勾选显示一站式服务大厅选择面板
    handleChange(val) {
      this.oneStepPanel = false
      val.forEach((ele) => {
        if (ele === 2) {
          this.oneStepPanel = true;
        }
      });
    },
  }
};
</script>

<style lang="scss">
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 130px;
  height: 130px;
  line-height: 130px;
  text-align: center;
}
.avatar {
  width: 130px;
  height: 130px;
  display: block;
}
.avatar-uploader-text {
  color: #AEAEB4;
  font-size: 12px;
}
.showUnread {
  position: relative;
  left: -22px;
}
.list-one-line .el-tag--small{
  margin-right: 10px;
}
.text-label {
  padding-left: 10px;
  img {
    border-radius: 5px;
  }
}
</style>
